module.exports = __webpack_public_path__ + "img/crm.2a10415a.jpg";